var styleObj = {};
import createStyleSheet from "If_AdTool/common/createStyleSheet";
import UiTool from "If_AdTool/common/UiTool";
import Event from "If_AdTool/common/event";
import SendUrls from "If_AdTool/common/sendUrl";
function feedTW(adData,el) {
    if(adData.hasOwnProperty("extCode")&&adData.extCode){
        for(let key in adData.extCode){
            adData[key] = adData.extCode[key];
        }
    }
    let { title, desc,adTag=1,src,img,curl,clktk,imptk,adlogo,style,cName} = adData;
    if(!styleObj.hasOwnProperty(cName)){
        styleObj[cName] = cName + '-' + window.IfengAmgr.uuid();
        style = style.replace(new RegExp(cName,"g"),styleObj[cName]);
        createStyleSheet(style);
        console.log("创建样式",cName)
    }
    let className = styleObj[cName];
    let imgcontainer = 'imgcontainer-' + window.IfengAmgr.uuid();
    let content = adTag == 1 ? '<div class="' + className + '"><a href="' + curl + '" class="pic-' + className + '" id="' + imgcontainer + '" target="blank"><img src="' + img + '"></a><div class="text-' + className + '"><h2><a href="' + curl + '" target="blank">' + title + '</a></h2><p>' + desc + '</p></div><img src="' + adlogo + '" class="adlogo-' + className +'" style="opacity: .8;transform: scale(.8);"></div>':'<div class="'+className+'"><a href="'+curl+'" class="pic-'+className+'" id="'+imgcontainer+'" target="blank"><img src="'+img+'"></a><div class="text-'+className+'"><h2><a href="'+curl+'" target="blank">'+title+'</a></h2><p>'+desc+'</p></div></div>';
    el.innerHTML = content;
    UiTool.imgResize(imgcontainer,adData.img,3);
    SendUrls(imptk);
    Event.addEvent(el,"click",()=>{
        SendUrls(clktk);
    })
}
if(typeof  window.IfengAmgr !=undefined){
    window.IfengAmgr.tplLib.feedTW = {render:feedTW,version:"1.0.1"};
}


